import React from 'react';
import { useSearchSort } from '../../components/kitsters/useSearchSort';

const TableVendor = ({ vendordata }) => {
  const { view, query, setQuery, sortKey, sortDir, toggleSort } = useSearchSort(vendordata);

  const rows = [];
  for (let i = 0; i < view.length; i++) {
    const a = view[i];
    const documentNames = a.documents?.map(doc => doc.file_name).join(', ') || '—';
    rows.push(
      <tr key={a.contact_id || i}>
        <td>{a.contact_name}</td>
        <td>{documentNames}</td>
        <td>{a.outstanding_payable_amount}</td>
        <td>
          <a
            href={`https://books.zoho.in/app/60022040726#/vendors/${a.contact_id}?filter_by=Status.All&per_page=200&sort_column=created_time&sort_order=D`}
            target="_blank"
            rel="noreferrer"
          >
            view
          </a>
        </td>
      </tr>
    );
  }

  const th = (key: string, label: string) => (
    <th className="th-sort" onClick={() => toggleSort(key)}>
      {label} {sortKey === key ? (sortDir === 'asc' ? '▲' : '▼') : ''}
    </th>
  );

  return (
    <>
      <input className="tbl-search" placeholder="Search…" value={query} onChange={e => setQuery(e.target.value)} /> 
      <table className="grid">
        <thead>
          <tr>
            {th('vendor_name', 'vendor name')}
            {th('documents', 'documents')}
            {th('outstanding_payable_amount', 'outstanding payable amount')}
            <th style={{ width: '80px' }}>action</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </>
  );
};

export default TableVendor;